import { render, staticRenderFns } from "./PostingForm.vue?vue&type=template&id=59ed3b96"
import script from "./PostingForm.vue?vue&type=script&lang=js"
export * from "./PostingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports